module.exports = __webpack_public_path__ + "img/chrome16.e133662e.png";